import React from "react";
import { IoMdAdd } from "react-icons/io";
import StableWalletCard from "./StableWalletCard";
import { ResponseData } from "../../../pages/dashboard/WalletLayout";
import { useLpStore } from "../../../store/useLiquidityPartner";

interface Props {
  onRampData: ResponseData[]; // Define the prop type as an array of ResponseData
}

const OnRampInfo = ({ onRampData }: Props) => {
  const lp = useLpStore((state) => state.Lp);
  console.log(onRampData);
  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="title  ">
          <h1 className="text-2xl  text-[#071827]">{lp.name}</h1>
          <p className="text-sm text-[#676767]">
            Last transaction -
            <span className="text-sm text-[#071827]">20 minutes ago</span>
          </p>
        </div>

        <div className="">
          <button
            // onClick={handleAddModal}
            className="flex items-center justify-center p-2 rounded-md bg-[#fff] text-[#0eb683]  active:scale-90 cursor-pointer border border-[#0eb683] transition-all duration-300 ease-in "
          >
            <IoMdAdd size={23} />
            <span className="ml-1">Add Stablecoin Wallet</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-[repeat(auto-fill,_minmax(15rem,_1fr))] gap-3 mt-5">
        {onRampData.map((data, index) => (
          <StableWalletCard key={index} lp={data} />
        ))}
      </div>
    </div>
  );
};

export default OnRampInfo;
